const initialState = {
  show: false,
  name: '',
};

export default function filterPresetReducer(state = initialState, action) {
  switch (action.type) {
    case 'general.filter_preset/SET_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
